import { useEffect, useState } from "react"
import { useRoutesHooks } from "../../../../../features/routes"
import { DetailWrapper, SpinnerDiv } from "../../../../../features/ui"
import { Delivery, DeliveryOrder, useDeliveryOrderLoaders } from "../../../../deliveries"
import { RoadmapDetail } from "./roadmapDetail"
import { Address } from "../../../../../features/address"
import { Roadmap } from "../../../state/types"
import { useRoadmapHooks } from "../../../hooks/roadmapHooks"
import { Operation, useOperationLoaders } from "../../../../operations"

export const Loader = () => {
    const { dataType } = useRoutesHooks().parseUrl()
    const roadmap = dataType! as Roadmap

    const [ready, setReady] = useState(false)
    const [shipments, setShipments] = useState<Delivery[]>([])
    const [shipmentOrders, setShipmentOrders] = useState<DeliveryOrder[]>([])
    const [operations, setOperations] = useState<Operation[]>([])
    const [routeAddressesData, setRouteAddressesData] = useState<Map<string, Address>>(new Map())

    const { getRouteData } = useRoadmapHooks()

    const deliveryOrderLoaders = useDeliveryOrderLoaders()
    const operationLoaders = useOperationLoaders()

    const load = async () => {
        const routeData = await getRouteData(roadmap)
        setShipments(routeData.shipments)
        const { loadDeliveryOrders } = deliveryOrderLoaders()
        const loadedShipmentOrders = await loadDeliveryOrders(routeData.shipments.map(shipment => shipment.orderId!))
        setShipmentOrders(loadedShipmentOrders)
        const { loadDeliveriesOperations } = operationLoaders()
        const loadedOperations = await loadDeliveriesOperations(loadedShipmentOrders)
        setOperations(loadedOperations)
        setRouteAddressesData(routeData.routeAddressesData)
    }
    
    useEffect(() => {
        load().then(() => setReady(true))
    }, [])

    return ready ? (
        <RoadmapDetail
            shipments={shipments}
            shipmentOrders={shipmentOrders}
            operations={operations}
            routeAddressesData={routeAddressesData}
        />
    ) : <SpinnerDiv />
}

export const RoadmapDetailLoader = () => (
    <DetailWrapper>
        <Loader />
    </DetailWrapper>
)
